export const ROOT = '/';

export const AUTH = '/authentication';
export const AUTH_SIGN_UP = '/authentication?mode=signUp';
export const AUTH_SIGN_IN = '/authentication?mode=signIn';
export const AUTH_FORGOT_PASSWORD = '/authentication?mode=forgotPassword';
export const AUTH_RESET_PASSWORD = '/authentication?mode=resetPassword';
export const AUTH_VERIFY_EMAIL = '/authentication?mode=verifyEmail';
export const AUTH_VERIFY_PLEASE = '/authentication?mode=verifyPlease';

/* SZ: Dashboard will be added later */
export const USER_DASHBOARD = '/dashboard';

/* SZ: Capsules pages not needed. All of them must be removed from sources */
/* Sratring from here */
export const USER_CAPSULES = '/capsules';
export const USER_CAPSULE_VIEW = '/capsules/:id/view';
export const USER_CAPSULE_EDIT = '/capsules/:id/edit';
export const USER_CREATE_CAPSULE = '/create-capsule';
export const USER_CREATE_CAPSULE_CONTINUE = '/create-capsule/:id';
/* Till here */

export const USER_PROFILE = '/profile';
export const USER_PROFILE_TOP_UP_BALANCE = '/profile/top-up-balance';
export const USER_PROFILE_PAYMENTS_HISTORY = '/profile/payments-history';
export const USER_PRICING = '/pricing';
export const USER_FAQ = '/faq';
export const USER_SUPPORT = '/support';
export const USER_PRIVACY_POLICY = '/privacy-policy';
export const USER_TERMS_OF_SERVICE = '/terms-of-service';
export const USER_PAY = '/pay/:id';

/* SZ: This is not needed. HOWEVER, it may be used to prolong allPWD premium subscription, or may not be used... */
export const USER_CAPSULE_PROLONG = '/prolong/:id';

export const WEB_SITES_LOGIN = '/web-sites-logins';
export const FILE_ACCESS_PASSWORDS = '/file-access-passwords';
export const BANK_CARDS = '/bank-cards'
export const CRYPTO_WALLETS = '/crypto-wallets'
export const SERVER_LOGINS = '/server-logins';
export const HARDWARE_DEVICES = '/hardware-devices'
export const OTHER_LOGINS = '/other-logins'
export const CONTACTS = '/contacts'
